module.exports = __webpack_public_path__ + "img/box4-active2.8d15e100.png";